import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, PaginatedTable, PaginatedTableColumn, Section } from '@common/components';
import { formatDate } from '@common/utils';
import { GENETIC_COUNSELING_TRANSLATION } from '@modules/genetic-counseling/constants';
import { useReferralsTable } from '@modules/genetic-counseling/hooks';
import { ReferralListItem, ReferralStatuses, UpcomingReferral } from '@modules/genetic-counseling/types';
import { getAppointmentTime } from '@/modules/genetic-counseling/utils';
import BasicFilter from '../shared/BasicFilter/BasicFilter';

const Upcoming: FC = () => {
  const { t } = useTranslation(GENETIC_COUNSELING_TRANSLATION);
  const {
    dataTable,
    commonColumns,
    pageSize,
    handleChangeSorting,
    handleChangePage,
    handleFilterChange,
    handleRowClick,
  } = useReferralsTable<UpcomingReferral>(ReferralStatuses.UPCOMING);

  const columns: Array<PaginatedTableColumn<ReferralListItem> | PaginatedTableColumn<UpcomingReferral>> = [
    {
      key: 'dateTime',
      label: t('table.appointment_date'),
      render: (_column: PaginatedTableColumn<UpcomingReferral>, item: UpcomingReferral) => {
        const startTime = item?.appointmentStartTime;
        const endTime = item?.appointmentEndTime;
        const timezone = item?.timeZone;

        const appointmentDate = startTime ? formatDate(startTime, 'MM/dd/yyyy') : '--';
        const apptTime = timezone && getAppointmentTime(startTime, endTime, timezone);

        return (
          <>
            {appointmentDate}
            <br />
            {apptTime}
          </>
        );
      },
      sort: true,
      width: '20%',
    },
    ...commonColumns,
  ];

  return (
    <Section title={t('upcoming.section_title')}>
      <Box>
        <BasicFilter onFilterChange={handleFilterChange} />
        <PaginatedTable
          columns={columns}
          data={dataTable}
          isPaginated={false}
          onRowClick={handleRowClick}
          onSortingChange={handleChangeSorting}
          onPageChange={handleChangePage}
          pageSize={pageSize}
          rowClickable
        />
      </Box>
    </Section>
  );
};

export default Upcoming;
